import React, { ReactElement } from 'react';
import Panel from '../card/Panel';
import { RootState } from '../../../store';
import { useSelector } from 'react-redux';
import { Payer } from '../../models/payer.model';
import { NHCXState } from '../../../store/models/nhcxModel';
import { Col, Row } from 'antd';
import { getDefaultStr } from '../../../modules/crm/inPatient/service/crmUtils';
import { NewAdmissionState } from '../../../store/models/newAdmissionModel';
import NumberFormatView from '../NumberFormatView/NumberFormatView';
const PolicyDetailsGuide = (): ReactElement => {
  const configuredPayers = useSelector((state: RootState): Payer[] => state.payerList.allPayers);
  const { selectedPolicyDetail, coverageResponse, ipoResponse } = useSelector((state: RootState): NHCXState => state.nhcx);
  const selectedPolicyPayer = configuredPayers.filter((payer: any): any => payer?.key === String(selectedPolicyDetail?.payerId));
  const {selectedBeneficiaryDetail, admissionFormVal} = useSelector((state: RootState): NewAdmissionState => state.newAdmission || []);
  const { policyStartDate, policyEndDate }: any = selectedBeneficiaryDetail || {};
  const formattedPolicyStartDate = policyStartDate?.split(' ')?.[0];
  const formattedPolicyEndDate = policyEndDate?.split(' ')?.[0];
  const imageSrc = selectedPolicyPayer[0]?.payerIcon;
  const balanceSumInsured = coverageResponse?.balanceSumInsured;
  const sumInsured = coverageResponse?.sumInsured;
  const policyNumber = admissionFormVal?.customerDetail?.policyNumber;
  return (
    <Panel
      className="timeline-scroll"
    >
    <Row className="policyCardHeader">
    <Col md={20}>Policy Highlights</Col><Col md={2} className="payer-logo"> <img src={imageSrc}/>
    </Col>
    </Row>
    <Row className="policyDetails">
    <Col md={10}>
        <p className="label-title">Policy Number</p>
        <div data-testid="claimDetailHeader" className="label-value fsize_sm wrap">
        {getDefaultStr(policyNumber, true)}
        </div>
      </Col>
      <Col md={6} className="mx-1">
      <p className="label-title">Start Date</p>
        <div data-testid="claimDetailHeader" className="label-value fsize_sm">
        {getDefaultStr(formattedPolicyStartDate, true)}
        </div>
      </Col>
      <Col md={6}>
        <p className="label-title">End Date</p>
        <div data-testid="claimDetailHeader" className="label-value fsize_sm">
        {getDefaultStr(formattedPolicyEndDate, true)}
        </div>
      </Col>
      </Row>
      <Row className="Geography-label">
        <Col md={24}>
          <p className="label-title">Geography: <span className="geography-text">{ipoResponse?.plan || '-'}</span></p>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
        <p className="label-title">Sum Insured</p>
        <div data-testid="claimDetailHeader" className="policyGuideHeader">
        <NumberFormatView amount={sumInsured} prefix={'₹ '} fixedDecimalScale={true} policyGuideCard={true}/>        </div>
        </Col>
        <Col md={12}>
        <p className="label-title">Balance Sum Insured</p>
        <div data-testid="claimDetailHeader" className="policyGuideHeaderBSI" >
        <NumberFormatView amount={balanceSumInsured} prefix={'₹ '} fixedDecimalScale={true} policyGuideCard={true}/>        </div>
        </Col>
      </Row>
    </Panel>
  );
};

export default PolicyDetailsGuide;
